export const getColorByEnv = (env: string | undefined): string | undefined => {
    if (env === "BAS") return "#f97316";
    if (env === "EID") return "#a855f7";
    if (env === "PROD") return "#22c55e";
    return undefined;
  };